export default {"src":"/_next/static/media/usdt.1dfbdae8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};